<template>
  <div class="property_wraps">
    <div class="pro_top">{{property.label}}</div>
	<div class="pro_con" @change="type">
		<div class="ShopTemplate">
			<el-radio v-model="radio" label="1">样式一</el-radio>
			<el-form ref="form" label-width="80px" style="background-color: bisque;">
				<div class="demo-input-suffix" style="width: 55%;">
					<el-input
					  placeholder="请输入内容"
					  style="border-radius: 20px;"
					  suffix-icon="el-icon-search"
					  v-model="input5">
					  <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
					</el-input>
				</div>
				<div class="display">
					<div class="name">
						<div class="marginTop10" style="display: flex;font-size: 24px;">丽园蛋糕房<div class="update" v-if="property.updates==1">上新</div></div>
						<div class="font12 marginTop10">{{property.textareas}}</div>
						<!-- 当日新鲜出炉，保证新鲜 -->
					</div>
					<div class="marginLeft5">
						<img src="@/assets/imgs/share1.png"></img>
					</div>
				</div>
				<div class="display marginTop30 cumulativeBox">
					<div class="grandTotal">累计访问{{property.visits}}</div>
					<div class="grandTotal">累计出售{{property.sales}}</div>
					<!-- <div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/defultbg2@3x.png" alt=""><p>认证企业</p></div> -->
					<div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/Authentication.png" alt=""></div>
				</div>
			</el-form>
		</div>
		<div class="ShopTemplate">
			<el-radio v-model="radio" label="2">样式二</el-radio>
			<div class="topBox">
				<el-form ref="form" label-width="80px">
					<div class="display">
						<div class="name">
							<div class="marginTop10 font20" style="display: flex;">丽园蛋糕房<div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/Authentication.png" alt=""></div></div>
							<!-- <div class="font12 marginTop10 marginBottom10">{{property.textareas}}</div> -->
							<!-- 当日新鲜出炉，保证新鲜 -->
							<div class="display cumulativeBox" style="padding: 0px 0px 15px;">
								<div class="grandTotal">累计访问{{property.visits}}</div>
								<div class="grandTotal">累计出售{{property.sales}}</div>
							</div>
						</div>
					</div>
					<div class="demo-input-suffix" style="width: 90%;">
						<el-input
						  placeholder="请输入内容"
						  style="width: 100%;"
						  v-model="input6"
						  suffix-icon="el-icon-search"
						  @input="search">
						  <!-- <i slot="prefix" class="el-input__icon el-icon-search aaa"></i> -->
						</el-input>
					</div>
				</el-form>
			</div>
			<div class="imageBox">
				<img :src="fileList" alt="">
			</div>
		</div>
		<div class="ShopTemplate">
			<el-radio v-model="radio" label="3">样式三</el-radio>
			<el-form ref="form" label-width="80px" style="background-color: bisque;">
				<div style="display: flex;">
					<div style="z-index: 999;">
						<img class="image" src="@/assets/imgs/bitmap.png"></img>
					</div>
					<div class="demo-input-suffix" style="width: 75%;">
						<el-input
						  placeholder="请输入内容"
						  v-model="input7"
						  suffix-icon="el-icon-search"
						  style="margin-left: -10px;">
						  <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
						</el-input>
					</div>
				</div>
				
				<div class="display">
					<div class="name">
						<div class="marginTop10" style="display: flex;font-size: 24px;">丽园蛋糕房<div class="update" v-if="property.updates==1">上新</div></div>
						<div class="font12 marginTop10">{{property.textareas}}</div>
						<!-- 当日新鲜出炉，保证新鲜 -->
						
					</div>
					<div class="marginLeft5" style="margin-top: 30px;">
						<div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/Authentication.png" alt=""></div>
					</div>
				</div>
			</el-form>
		</div>
	</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
		  <div @change="updateLabel" class="labelBox" v-if="radio==1">
		  	<span>上新标签</span>
		  	<div>
		  		<el-radio v-model="update" label="1">展示</el-radio>
		  		<el-radio v-model="update" label="2">不展示</el-radio>
		  	</div>
		  </div>
		  <div class="font1" v-if="radio==1">新增商品后，会在店铺名称后面展示上新标签</div>
		  <div class="AccessNum" v-if="radio==1 || radio==2">
			  初始化累计访问数:
			  <div class="demo-input-suffix" style="width: 55%;">
				  <el-input v-model="visit" @input="Access" placeholder="请填写初始化访问数"></el-input>
			  </div>
		  </div>
		  <div class="AccessNum" v-if="radio==1 || radio==2">
			  初始化累计售出数:
			  <div class="demo-input-suffix" style="width: 55%;">
				  <el-input v-model="sale" @input="sell" placeholder="请填写初始化售出数"></el-input>
			  </div>
		  </div>
		  <div class="font1 marginTop10">初始化累计数为店铺默认展示数量</div>
		  <div class="font1">展示总数=初始化累计数+实际累计数</div>
		  <div class="searchBox">
			  搜索框默认展示商品:
			  <div style="width: 55%;">
				  <el-select v-model="id" @change="demonstrate" placeholder="请选择想要展示的商品">
				      <el-option
				        v-for="item in options"
				        :key="item.id"
				        :label="item.goods_name"
				        :value="item.id"
				  					style="position: relative;left: 0px;">
				      </el-option>
				    </el-select>
			  </div>
			  
		  </div>
		  <div class="font1 marginTop10">可选择已有商品在搜索框处进行默认展示，不选择将显示默认文案</div>
		  <div @change="companyIcon" class="labelBox marginTop30">
		  	<span>认证企业图标</span>
		  	<div>
		  		<el-radio v-model="enterprise" label="1">展示</el-radio>
		  		<el-radio v-model="enterprise" label="2">不展示</el-radio>
		  	</div>
		  </div>
		  <div class="CommodityTitle marginTop30" v-if="radio==1 || radio==3">
		  	<span>店铺简介:</span>
			<div style="width: 80%;">
				<el-input
				  type="textarea"
				  placeholder="请输入店铺简介"
				  v-model="textarea"
				  maxlength="60"
				  show-word-limit
				  @input="synopsis"
				>
				</el-input>
			</div>
		  	
		  </div>
		  <div class="marginTop30" v-if="radio==2">
			  <el-form-item label="店铺宣传图:" label-width="90px">
				  <el-upload
				      :action="uploadImg"
				      :data="data_"
				      list-type="picture-card"
				      :limit="1"
				      :file-list="fileList"
				      :on-success="handleSuccess"
				      :on-preview="handlePictureCardPreview"
				      :on-remove="handleRemove"
				      :before-upload="beforeAvatarUpload">
				    <i class="el-icon-plus"></i>
				  			<!-- <button class="btn">
				  				<i class="el-icon-plus"></i>
				  				添加图片
				  			</button> -->
				  </el-upload>
				  <el-dialog :visible.sync="dialogVisible" size="tiny">
				    <img width="100%" :src="dialogImageUrl" alt="">
				  </el-dialog>
				  <p class="infodescribe">图片大小不超过1M,支持jpg、png格式，最多可上传9张</p>
				  <p class="infodescribe">建议所有轮播图比例一致，轮播效果更佳</p>
			  </el-form-item>
			  
		  </div>
        <!-- <el-form label-width="80px">
          <el-form-item label="组件标题:">
            <el-input v-model="property.label"></el-input>
          </el-form-item>
        </el-form>
        <el-form-item label="内容:">
          <el-input type="textarea" v-model="property.body" class="companytext"></el-input>
        </el-form-item> -->
      </el-form>
    </div>
  </div>
</template>
<script>
	import api from "@/api.js"
	import apii from "../../../vue.config.js"
  export default {
    props: ["property"],
    data() {
      return {
		uploadImg: api.uploadTokenImg,
		data_: {token: sessionStorage.getItem("token")},
		dialogImageUrl: '',
        dialogVisible: false,
		radio: "1",
		update: "1",
		enterprise: "1",
		input5: '',
		input6: '',
		input7: '',
        fileList:'',
		visit: '',
		sale: '',
		textarea: '',
		options: [],
		// options: [{
		//           value: '1',
		//           label: '黄金糕'
		//         }, {
		//           value: '2',
		//           label: '双皮奶'
		//         }, {
		//           value: '3',
		//           label: '蚵仔煎'
		//         }, {
		//           value: '4',
		//           label: '龙须面'
		//         }, {
		//           value: '5',
		//           label: '北京烤鸭'
		//         }],
		        id: '',
        form: {
			updates: 1,
			radios: 1,
			name: "样式一",
			enterprises: 1,
			visits: 0,
			sales: 0,
			textareas: '',
			pic: [],
			id: '',
          body: ''
        }
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    created(){
		// console.log(apii,"apii")
		this.input5 = this.property.search_goods_name
		this.input6 = this.property.search_goods_name
		this.input7 = this.property.search_goods_name
		this.AccessToGoods()
    },
    mounted() {
		console.log(this.property,"this.property119=============")
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
		//查询商品列表
		AccessToGoods(){
			let params = {
			//   page: this.page.pageindex,
			//   check_type: this.formdata.check_type,
			//   goods_type: this.formdata.goods_type,
			//   name: this.formdata.name,
			//   cat_id: this.formdata.cat_id[this.formdata.cat_id.length - 1],
			//   size: this.page.pagesize
			};
			this.axios
			    .post(api.decorate_getGoods, params)
			    .then(response => {
					// console.log(response,"response452====*********")
			      if (response.data.code == 0) {
			        this.options = response.data.list;
			        // this.page.total = response.data.all_page;
			      }
							// console.log(this.options,"this.options432======****=====")
			    })
			    .catch(response => {
			    });
		},
		type(e){
			console.log(e,"e184=================")
			this.radio = e.target.value
			this.form.radios = e.target.value
			if(this.form.radios ==1){
				this.form.name == "样式一"
			}else if(this.form.radios ==2){
				this.form.name == "样式二"
			}else if(this.form.radios ==3){
				this.form.name == "样式三"
			}
		},
		// 样式二搜索框
		search(e){
			console.log(e,"e191=================")
		},
		// 上新标签
		updateLabel(e){
			console.log(e,"e58=================")
			this.update = e.target.value
			this.form.updates = e.target.value
		},
		//初始化累计访问数
		Access(e){
			console.log(e,"e70=================")
			this.visit = e
			this.form.visits = e
		},
		// 初始化累计售出数
		sell(e){
			console.log(e,"e78=================")
			this.sale = e
			this.form.sales = e
		},
		// 搜索框默认展示商品
		demonstrate(e){
			console.log(e,"e111=================")
			this.id = e
			this.form.id = e
			for(let i in this.options){
				if(e == this.options[i].id){
					this.form.search_goods_name = this.options[i].goods_name
				}
			}
		},
		companyIcon(e){
			console.log(e,"e124=================")
			this.enterprise = e.target.value
			this.form.enterprises = e.target.value
		},
		// 店铺简介
		synopsis(e){
			console.log(e,"e111=================")
			this.textarea = e
			this.form.textareas = e
		},
		handleRemove(file, fileList) {
				  // console.log(fileList,file,"fileList125==========")
		  let pic = [];
		  for (let i in  fileList) {
		    if(fileList[i].response){
		      pic.push(fileList[i].response.path)
		    }else{
		      pic.push(fileList[i].url);
		    };
		  };
		  this.form.pic = pic;
		  // this.fileList = pic;
		},
		handlePictureCardPreview(file) {
		  this.dialogImageUrl = file.url;
		  this.dialogVisible = true;
		},
		handleSuccess(response, file, fileList) {
				  // console.log(file,"file148=======")
				  console.log(fileList,"fileList141==========")
		  if (response.code === 0) {
		    let pic = [];
		    for (let i in  fileList) {
		      if(fileList[i].response){
		        pic.push(fileList[i].response.path)
		      }else{
		        pic.push(fileList[i].url);
		      };
			  console.log(pic,"pic99999999999999")
		    };
			
		    this.form.pic = pic;
		    this.fileList = pic;
		  } else {
		    this.$message.error(res.msg);
		  }
		  this.loadingStatus.close();
		},
		beforeAvatarUpload(file) {
		  const isLt2M = file.size / 1024 / 1024 < 1;
		
		  if (!isLt2M) {
		    this.$message.error('上传图片大小不能超过 1MB!');
		  }
		  this.loadingStatus = this.$loading({
		    lock: true,
		    text: '上传中',
		    spinner: 'el-icon-loading',
		    background: 'rgba(0, 0, 0, 0.4)',
		    customClass:'fontColor'
		  });
		  return isLt2M;
		},
    }
  };
</script>

<style>
	.aaa{
		position: relative;
		left: 275px;
	}
	.ShopTemplate{
		width: 100%;
		/* height: auto; */
		border: 1px solid black;
		margin-bottom: 10px;
	}
	.labelBox{
		display: flex;
		margin-bottom: 10px;
	}
	.labelBox >div{
		position: absolute;
		right: 10px;
	}
	.AccessNum{
		display: flex;
		margin-top: 25px;
	}
	.el-input{
		width: 50%;
		margin-left: 20px;
	}
	.el-input__inner{
		height: 25px;
		/* border-radius: 15px; */
	}
	.font1{
		color: darkgray;
	}
	.font20{
		font-size: 18px;
	}
	.marginTop10{
		margin-top: 10px;
	}
	.marginTop30{
		margin-top: 30px;
	}
	.marginBottom10{
		margin-bottom: 10px;
	}
	.searchBox{
		margin-top: 25px;
		display: flex;
	}
	/* .el-input__icon{
		margin-top: 0px;
	} */
	.image{
		width: 25px;
		margin-left: 20px;
		z-index: 50;
	}
	.el-select .el-input .el-select__caret{
		position: relative;
		left: 0px;
	}
	.imageBox{
		width: 90%;
		height: auto;
		margin-left: 5%;
		margin-top: -35px;
	}
	.imageBox >img{
		width: 100%;
		height: auto;
	}
	/* .el-upload--picture-card{
		width: 148px;
		border: 1px dashed #c0ccda;
	}
	.el-upload--picture-card i{
		font-size: 28px;
		color: #8c939d;
	} */
</style>

